import { createContext, useContext } from 'react';
import logger from '../utils/logger';

/**
 * Context to hold the Matrix client instance.
 * This is a lean context that only provides the client itself.
 * All derived state should be managed by hooks.
 */
export const MatrixContext = createContext(null);

/**
 * Custom hook to easily access the Matrix client from the context.
 * @returns {import('matrix-js-sdk').MatrixClient} The Matrix client instance.
 */
export const useMatrixClient = () => {
  const client = useContext(MatrixContext);
  
  if (!client) {
    logger.warn('No Matrix client available in context');
  }
  
  return client;
};
